class ProductCustomiserCategory extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      contentToggler: this.querySelector('[data-toggle-category-content]'),
      content: this.querySelector('[data-category-content]'),
      imageWrappers: this.querySelectorAll('product-customiser-addon-product-image-wrapper'),
      descriptions: this.querySelectorAll('product-customiser-addon-product-description'),
      slider: this.querySelector('[data-images-slider]'),
    }

    this.required = this.dataset.required == 'true';
    this.requiredItemsCount = parseInt(this.dataset.requiredItemsCount);
    this.valid = this.required ? false : true;

    this.addedItems = [];

    this.elements.contentToggler.addEventListener('click', this.toggleContent.bind(this));

    this.elements.imageWrappers.forEach(
      (imageWrapper) => imageWrapper.addEventListener('productCustomiserAddonProductImageWrapperClicked', this.handleImageWrapperClick.bind(this))
    );

    this.elements.descriptions.forEach(
      (description) => {
        description.addEventListener('productCustomiserAddonVariantChanged', this.handleVariantChange.bind(this));
        description.addEventListener('productCustomiserAddAddon', this.handleAddAddon.bind(this));
        description.addEventListener('productCustomiserRemoveAddon', this.handleRemoveAddon.bind(this));
      }
    );    
  }

  toggleContent(event) {
    event.preventDefault();
    event.currentTarget.classList.toggle('opened');
    this.elements.content.slideToggle();
  }

  handleImageWrapperClick(event) {
    const activeItemIndex = event.detail.index;
    this.elements.imageWrappers.forEach(
      (imageWrapper) => {
        if (activeItemIndex == imageWrapper.index) {
          imageWrapper.classList.add('active');
        } else {
          imageWrapper.classList.remove('active');
        }
      }
    );

    this.elements.descriptions.forEach(
      (description) => {
        if (activeItemIndex == description.index) {
          description.classList.add('active');
        } else {
          description.classList.remove('active');
        }
      }
    );
  }

  handleVariantChange(event) {
    const {variant, index} = event.detail;
    const variantAdded = this.checkIfVariantAdded(variant);

    const matchingImageWrapper = Array.from(this.elements.imageWrappers).find(
      (imageWrapper) => imageWrapper.index == index
    );

    const matchingDescription = Array.from(this.elements.descriptions).find(
      (description) => description.index == index
    )

    matchingImageWrapper.updateFeaturedImage(variant);

    if (variantAdded) {
      matchingImageWrapper.classList.add('added');
      matchingDescription.classList.add('added');
    } else {
      matchingImageWrapper.classList.remove('added');
      matchingDescription.classList.remove('added');
    }
  }

  checkIfVariantAdded(variant) {
    const added = this.addedItems.find(
      (item) => item.variant.id == variant.id
    );

    return !!added;
  }

  handleAddAddon(event) {
    const {variant, quantity, index} = event.detail;
    this.addedItems.push({
      variant: variant,
      quantity: quantity,
    });

    this.checkValidity();

    const matchingImageWrapper = Array.from(this.elements.imageWrappers).find(
      (imageWrapper) => imageWrapper.index == index
    );

    const matchingDescription = Array.from(this.elements.descriptions).find(
      (description) => description.index == index
    );

    matchingImageWrapper.classList.add('added');
    matchingDescription.classList.add('added');

    this.dispatchEvent(new CustomEvent('productCustomiserAddonsUpdated'));
  }

  handleRemoveAddon(event) {
    const {variant, index} = event.detail;

    this.addedItems = this.addedItems.filter(
      (item) => {return item.variant.id != variant.id}
    );

    this.checkValidity();

    const matchingImageWrapper = Array.from(this.elements.imageWrappers).find(
      (imageWrapper) => imageWrapper.index == index
    );

    const matchingDescription = Array.from(this.elements.descriptions).find(
      (description) => description.index == index
    );

    matchingImageWrapper.classList.remove('added');
    matchingDescription.classList.remove('added');

    this.dispatchEvent(new CustomEvent('productCustomiserAddonsUpdated'))
  }

  checkValidity() {
    if (this.required) {
      this.valid = this.addedItems.length >= this.requiredItemsCount;
    } else {
      this.valid = true;
    }
  }
}

customElements.define('product-customiser-category', ProductCustomiserCategory);

class ProductCustomiserAddonProductImageWrapper extends HTMLElement {
  constructor() {
    super();
    this.index = parseInt(this.dataset.index);
    this.elements = {
      image: this.querySelector('[data-addon-image]'),
    }

    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    event.preventDefault();
    this.dispatchEvent(new CustomEvent('productCustomiserAddonProductImageWrapperClicked', {
      detail: {
        index: this.index
      }
    }));
  }

  updateFeaturedImage(variant) {
    this.elements.image.src = variant.featuredImage;
  }
}

customElements.define('product-customiser-addon-product-image-wrapper', ProductCustomiserAddonProductImageWrapper);

class ProductCustomiserAddonProductDescription extends HTMLElement {
  constructor() {
    super();

    this.parentCategory = this.closest('product-customiser-category');

    this.index = this.dataset.index;
    this.elements = {
      variantSelector: this.querySelector('[data-addon-product-selector]'),
      quantityInput: this.querySelector('[data-quantity-input]'),
      addButton: this.querySelector('[data-add-addon]'),
      removeButton: this.querySelector('[data-remove-addon]'),
      variantPrice: this.querySelector('[data-price-container]'),
      initiallySelectedVariantInput: this.querySelector('[data-addon-initially-selected-variant]'),
      preorderContainer: this.querySelector('[data-addon-product-preorder]'),
      preorderDate: this.querySelector('[data-preorder]'),
    }

    this.texts = {
      preorderText: this.dataset.preorderText,
      addButtonText: this.dataset.addButtonText,
    }

    this.selectedVariant = {
      id: this.elements.initiallySelectedVariantInput.value,
      price: this.elements.initiallySelectedVariantInput.dataset.price,
      title: this.elements.initiallySelectedVariantInput.dataset.variantTitle,
      productTitle: this.elements.initiallySelectedVariantInput.dataset.productTitle,
      featuredImage: this.elements.initiallySelectedVariantInput.dataset.featuredImage,
      preorderDate: this.elements.initiallySelectedVariantInput.dataset.preorderDate,
    }

    if (this.elements.variantSelector) {
      this.elements.variantSelector.addEventListener('change', this.handleVariantChange.bind(this));
    }

    if (this.elements.addButton) {
      this.elements.addButton.addEventListener('click', this.addAddon.bind(this));
      this.elements.removeButton.addEventListener('click', this.removeAddon.bind(this));
    }

    this.elements.quantityInput.addEventListener('change', this.handleQuantityInputChange.bind(this));

  }

  handleVariantChange(event) {
    const selector = event.target;
    const newVariantID = selector.value;

    const selectedOption = selector.querySelector(`option[value="${newVariantID}"]`);

    this.selectedVariant = {
      id: newVariantID,
      price: selectedOption.dataset.price,
      title: selectedOption.dataset.variantTitle,
      featuredImage: selectedOption.dataset.featuredImage,
      preorderDate: selectedOption.dataset.preorderDate,
    }

    this.updateSelectedVariantData();

    this.dispatchEvent(new CustomEvent('productCustomiserAddonVariantChanged', {
      detail: {
        variant: this.selectedVariant,
        index: this.index,
      }
    }));
  }

  updateSelectedVariantData() {
    this.elements.variantPrice.innerHTML = '+ ' + theme.Currency.formatMoney(this.selectedVariant.price, theme.settings.moneyFormat);

    if (this.elements.preorderContainer) {
      if (this.selectedVariant.preorderDate != 'null') {
        this.elements.addButton.querySelector('[data-text]').innerHTML = this.texts.preorderText;
        this.elements.preorderDate.innerHTML = this.selectedVariant.preorderDate;
        this.elements.preorderContainer.style.display = 'block';
      } else {
        this.elements.addButton.querySelector('[data-text]').innerHTML = this.texts.addButtonText;
        this.elements.preorderContainer.style.display = 'none';
      }
    }
  }

  addAddon(event) {
    event.preventDefault();
    this.dispatchEvent(new CustomEvent('productCustomiserAddAddon', {
      detail: {
        variant: this.selectedVariant,
        quantity: parseInt(this.elements.quantityInput.value),
        index: this.index,
      }
    }));
  }

  removeAddon(event) {
    event.preventDefault();
    this.dispatchEvent(new CustomEvent('productCustomiserRemoveAddon', {
      detail: {
        variant: this.selectedVariant,
        index: this.index,
      }
    }))
  }

  handleQuantityInputChange(event) {
    let valueToInt = parseInt(event.target.value) || 1;
    if (valueToInt <= 0) {
      valueToInt = 1;
    }
    event.target.value = valueToInt;
  }
}

customElements.define('product-customiser-addon-product-description', ProductCustomiserAddonProductDescription);

class ProductCustomiser extends HTMLElement {
  constructor() {
    super();
    const productInfo = this.closest('product-info');
    const productForm = productInfo.querySelector('form[is="product-form"]');

    this.elements = {
      orderItemsContainer: this.querySelector('[data-order-items-container'),
      orderItemsTotal: this.querySelector('[data-order-items-total]'),
      productForm: productForm,
      addToCartButton: productForm.querySelector('[type="submit"]'),
      quantityInput: productInfo.querySelector('[name="quantity"]'),
      variantIDInput: productForm.querySelector('[name="id"]'),
      sellingPlanInput: productInfo.querySelector('[name="selling_plan"]'),
    }

    this.mainProduct = JSON.parse(this.querySelector('[data-main-product-json]').innerHTML);
    const currentVariantID = this.elements.variantIDInput.value;
    this.currentVariant = this.mainProduct.variants.find(
      (variant) => variant.id == currentVariantID
    );

    this.selectedProducts = [];

    this.categories = this.querySelectorAll('product-customiser-category');
    this.categories.forEach(
      (category) => category.addEventListener('productCustomiserAddonsUpdated', this.handleProductCustomiserAddonsUpdated.bind(this))
    );

    if (this.elements.quantityInput) {
      this.elements.quantityInput.addEventListener('change', this.updateOrderItems.bind(this))
    }

    if (this.elements.sellingPlanInput) {
      const sellingPlanInputObserver = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes') {
            this.updateOrderItems();
          }
        }
      });

      const sellingPlanInputObserverConfig = { 
        attributes: true,          // Required to watch attributes
        attributeOldValue: true,   // Keeps track of the prior value
        attributeFilter: ['value'] // Optional: limit tracking to specific attributes
      };

      sellingPlanInputObserver.observe(this.elements.sellingPlanInput, sellingPlanInputObserverConfig);
    }

    this.elements.productForm.addEventListener('mainProductAddedToCart', this.addSelectedProductsToCart.bind(this));

    this.elements.variantIDInput.addEventListener('change', this.handleVariantChange.bind(this));

    this.checkCategoriesValidity();
    this.updateOrderItems();
  }

  handleVariantChange(event) {
    const newVariantID = event.target.value;
    this.currentVariant = this.mainProduct.variants.find(
      (variant) => variant.id == newVariantID
    );
    this.updateOrderItems();
  }

  handleProductCustomiserAddonsUpdated() {
    this.selectedProducts = [];

    this.categories.forEach(
      (category) => {
        this.selectedProducts = [...this.selectedProducts, ...category.addedItems];
      }
    );

    this.checkCategoriesValidity();
    this.updateOrderItems();
  }

  checkCategoriesValidity() {
    const invalidCategories = Array.from(this.categories).filter(
      (category) => !category.valid
    );

    if (invalidCategories.length) {
      this.elements.addToCartButton.setAttribute('disabled', 'disabled');
    } else {
      this.elements.addToCartButton.removeAttribute('disabled');
    }
  }

  updateOrderItems() {
    var _this = this;
    this.elements.orderItemsContainer.innerHTML = '';

    const sellingPlanId = this.elements.sellingPlanInput ? Number(this.elements.sellingPlanInput.value) : 0;
    const sellingPlanAllocation = sellingPlanId && this.currentVariant.selling_plan_allocations
      ? this.currentVariant.selling_plan_allocations.find((plan) => plan.selling_plan_id === sellingPlanId)
      : null;

    const currentVariantPrice = sellingPlanAllocation ? sellingPlanAllocation.price : this.currentVariant.price;
    
    const mainProductQuantity = this.elements.quantityInput ? parseInt(this.elements.quantityInput.value) : 1;
    this.elements.orderItemsContainer.insertAdjacentHTML('beforeend', `
      <div class="cas-ro-item" data-main-product data-variant-id="${this.currentVariant.id}" data-quantity="${mainProductQuantity}">
        <div class="cas-ro-item-title">${this.currentVariant.name}</div>
        <div class="cas-ro-item-quantity">x${mainProductQuantity}</div>
        <div class="cas-ro-item-price">${theme.Currency.formatMoney(currentVariantPrice * mainProductQuantity, theme.settings.moneyFormat)}</div>
      </div>
    `);

    let orderTotal = currentVariantPrice * mainProductQuantity;

    this.selectedProducts.map((item) => {
      const {variant, quantity} = item;
      orderTotal += variant.price * quantity;

      const lineTitle = variant.title == 'Default Title' ? variant.productTitle : (variant.productTitle + ' - ' + variant.title);

      _this.elements.orderItemsContainer.insertAdjacentHTML('beforeend', `
        <div class="cas-ro-item" data-variant-id="${variant}" data-quantity="${quantity}">
          <div class="cas-ro-item-title">${lineTitle}</div>
          <div class="cas-ro-item-quantity">x${quantity}</div>
          <div class="cas-ro-item-price">${theme.Currency.formatMoney(variant.price * quantity, theme.settings.moneyFormat)}</div>
        </div>
      `);
    });

    this.elements.orderItemsTotal.innerHTML = theme.Currency.formatMoney(orderTotal, theme.settings.moneyFormat);
  }

  addSelectedProductsToCart(event) {
    console.log(event);
    const {callback} = event.detail;

    const formData = {
      items: []
    };

    this.selectedProducts.map((item) => {
      formData.items.push({
        id: parseInt(item.variant.id),
        quantity: item.quantity
      });
    });

    let sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

    formData.sections = sectionsToBundle;
    formData['sections_url'] = window.location.pathname;

    fetch(`${theme.routes.cart_add_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
      .then((response) => response.json())
      .then(async (parsedState) => {
        if (parsedState.status) {
          console.log('response description: ', parsedState.description);
          console.log('response message: ', parsedState.message);
        }
        callback(parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
  }
}

customElements.define('product-customiser', ProductCustomiser);